import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsTabNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data : {
        id: props.jobId
      },
      customerAllJobsPage:props.customerAllJobsPage || false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      data: {
        id: nextProps.jobId
      },
      customerAllJobsPage:nextProps.customerAllJobsPage
    });
  }

  render() {
    return (
      <ul className="nav nav-tabs no-select">
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-main-details"}
            className="active"
          >
            <i className="fa fa-info-circle"></i> Details
          </a>
        </li>
        : null}
        
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-dropoff-appraisal"}
            className={(this.state.customerAllJobsPage) ? 'active' : ''}
          >
            <i className="fa fa-file-signature"></i> Service
          </a>
        </li>
        
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-pickup-appraisal"}
          >
            <i className="fa fa-file-signature"></i> Yard
          </a>
        </li>
        : null}

        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-paperwork"}
          >
            <i className="fa fa-file"></i> Paperwork
          </a>
        </li>
        : null}
        {/* <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-expenses"}
          >
            <i className="fa fa-file-invoice-dollar"></i> Expenses
          </a>
        </li> */}
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-invoice"}
          >
            <i className="fa fa-file-invoice"></i> Invoice
          </a>
        </li>
        : null }
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-driver-documents"}
          >
            <i className="fa fa-folder"></i> Documents
          </a>
        </li>
        : null }
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-driver-messages"}
          >
            <i className="fa fa-envelope"></i> Messages
          </a>
        </li>
        : null }
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-notifications"}
          >
            <i className="fa fa-bell"></i> Notifications
          </a>
        </li>
        : null }
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-tools"}
          >
            <i className="fa fa-tools"></i> Tools
          </a>
        </li>
        : null }
        {(!this.state.customerAllJobsPage) ?
        <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-settings"}
          >
            <i className="fa fa-cog"></i> Settings
          </a>
        </li>
        : null }
        {/* <li>
          <a
            data-toggle="tab"
            href={"#job-"+this.state.data.id+"-call-informations"}
          >
            <i className="fa fa-phone"></i> Call Details
          </a>
        </li> */}
        {(this.props.is_quote || this.props.is_quote_rejected) ?  // <--- Added Check
          <li className="ms-auto" style={{ padding: "5px" }}>
            <a href={`/quote/edit/${this.state.data.id}`} className="btn btn-primary btn-sm text-white">
              <i className="fa fa-edit"></i> Edit Quote
            </a>
          </li> : null                                            // <--- Added Else Null
        }
      </ul>
    );
  }
}